const translation: Record<string, string> = {
  "nav.home": "Strona Główna",
  "nav.kakobuy": "Kakobuy Spreadsheet",
  "nav.cssbuy": "CSSBuy Spreadsheet",
  "nav.superbuy": "Superbuy Spreadsheet",
  "nav.oopbuy": "Oopbuy Spreadsheet",
  "nav.blog": "Blog",

  "hero.title": "Kakobuy Spreadsheet",
  "hero.subtitle": "Największa Lista Produktów i Najlepsze Finds 2026",
  "hero.description": "Odkrywaj tysiące produktów, aktualne linki oraz najlepsze okazje dzięki Kakobuy Spreadsheet. Twoja brama do najlepszych znalezisk zakupowych.",
  "hero.cta_primary": "Sprawdź najnowszy Spreadsheet",
  "hero.cta_secondary": "Kup Teraz",
  "hero.cta_kakobuy": "Kakobuy Sheet",

  "trust.updated": "Aktualizowane listy produktów",
  "trust.verified": "Zweryfikowane informacje",
  "trust.free": "Darmowy dostęp",
  "trust.guides": "Przewodniki zakupowe",

  "about.title": "Czym jest Kakobuy Spreadsheet?",
  "about.paragraph1": "Kakobuy Spreadsheet to uporządkowana baza produktów, która pomaga użytkownikom szybciej znaleźć popularne produkty, najlepsze okazje oraz sprawdzone linki zakupowe. To kompleksowe narzędzie stworzone z myślą o osobach, które cenią sobie oszczędność czasu i efektywne zakupy online.",
  "about.paragraph2": "Naszym celem jest stworzenie największego przewodnika po produktach i spreadsheetach zakupowych. Niezależnie od tego, czy szukasz najnowszych sneakersów, modnych ubrań, czy unikalnych akcesoriów — Kakobuy Spreadsheet pomoże Ci znaleźć dokładnie to, czego potrzebujesz.",

  "features.title": "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
  "features.time.title": "Oszczędność czasu",
  "features.time.desc": "Nie musisz godzinami szukać produktów. Wszystkie najlepsze znaleziska w jednym miejscu, gotowe do przeglądania.",
  "features.products.title": "Najlepsze produkty",
  "features.products.desc": "Znajduj popularne i sprawdzone produkty wybrane przez społeczność. Każdy produkt z aktualnym linkiem i opisem.",
  "features.updates.title": "Aktualne informacje",
  "features.updates.desc": "Regularnie aktualizowane listy produktów gwarantują, że zawsze masz dostęp do najnowszych okazji i trendów.",

  "categories.title": "Przeglądaj kategorie produktów",
  "categories.subtitle": "Wybierz kategorię i odkryj najlepsze produkty w Kakobuy Spreadsheet",
  "categories.dropdown_label": "Wybierz kategorię",

  "cta.title": "Gotowy znaleźć najlepsze produkty?",
  "cta.description": "Nie czekaj — odkryj tysiące sprawdzonych produktów w Kakobuy Spreadsheet już teraz. Znajdź swoje ulubione okazje i zacznij oszczędzać na zakupach.",
  "cta.button": "Otwórz Kakobuy Spreadsheet",

  "footer.description": "Kakobuy Finds to niezależny przewodnik po produktach i spreadsheetach zakupowych. Nie jesteśmy powiązani z żadną platformą zakupową.",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.quick_links": "Szybkie linki",

  "article.back": "← Powrót do strony głównej",
  "article.read_more": "Czytaj więcej",
  "article.related": "Powiązane artykuły",
};

export default translation;